// extracted by mini-css-extract-plugin
module.exports = {"referral__credits__container":"referral_referral__credits__container__3fXOh","refer__container":"referral_refer__container__uZAWb"};